import { css, ThemedCssFunction, DefaultTheme } from 'styled-components';

export type CSSSnippet = ReturnType<ThemedCssFunction<DefaultTheme>>;

export type SupportedTextStyleTypes =
    'small' | 'xSmall' | 'medium' | 'large' |
    'xLarge' | 'lightSmall' | 'sectionHeading' | 'hero1' |
    'hero2' | 'hero3' | 'hero4' | 'hero5';

export type SupportedHeadingStyleTypes =
    'h1' | 'h2' |
    'h3' | 'h4' |
    'h5' | 'h6';

type StyleMap<TKey extends string> = {
    [key in TKey]: CSSSnippet;
};

export type TextStyles = StyleMap<SupportedTextStyleTypes>;

export type HeadingStyles = StyleMap<SupportedHeadingStyleTypes>;

export interface ITypographyPresets {
    textStyles: TextStyles;
    headings: HeadingStyles;
}

function generateTypographyStyles(fontType: SupportedTextStyleTypes | SupportedHeadingStyleTypes) {
    const getThemVariablesByFontType = ({ typography }: DefaultTheme) => typography[fontType];
    return css`
        font-weight: ${({ theme }) => getThemVariablesByFontType(theme).fontWeight};
        font-size: ${({ theme }) => getThemVariablesByFontType(theme).fontSize};
        letter-spacing: ${({ theme }) => getThemVariablesByFontType(theme).letterSpacing};
    `;
}

export const typographyPresets: ITypographyPresets = {
    textStyles: {
        xSmall: generateTypographyStyles('xSmall'),
        small: generateTypographyStyles('small'),
        lightSmall: generateTypographyStyles('lightSmall'),
        medium: generateTypographyStyles('medium'),
        large: generateTypographyStyles('large'),
        xLarge: generateTypographyStyles('xLarge'),
        sectionHeading: generateTypographyStyles('sectionHeading'),
        hero1: generateTypographyStyles('hero1'),
        hero2: generateTypographyStyles('hero2'),
        hero3: generateTypographyStyles('hero3'),
        hero4: generateTypographyStyles('hero4'),
        hero5: generateTypographyStyles('hero5')
    },
    headings: {
        h1: generateTypographyStyles('h1'),
        h2: generateTypographyStyles('h2'),
        h3: generateTypographyStyles('h3'),
        h4: generateTypographyStyles('h4'),
        h5: generateTypographyStyles('h5'),
        h6: generateTypographyStyles('h6')
    }
};
